var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLogoPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165,
    height: 23,
    viewBox: "0 0 165 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sd5ha"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.569 8.509a3.902 3.902 0 0 0-1.248-.746 4.261 4.261 0 0 0-1.475-.263c-.957 0-1.88.32-2.585.896-.704-.576-1.627-.896-2.585-.896-.506 0-1.008.09-1.476.263a3.903 3.903 0 0 0-1.249.748c-1.522 1.359-1.521 3.484.001 4.837l5.31 4.719 5.308-4.72c1.523-1.352 1.524-3.477-.001-4.838z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162.569 8.509a3.902 3.902 0 0 0-1.248-.746 4.261 4.261 0 0 0-1.475-.263c-.957 0-1.88.32-2.585.896-.704-.576-1.627-.896-2.585-.896-.506 0-1.008.09-1.476.263a3.903 3.903 0 0 0-1.249.748c-1.522 1.359-1.521 3.484.001 4.837l5.31 4.719 5.308-4.72c1.523-1.352 1.524-3.477-.001-4.838z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sd5ha)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fad755",
    d: "M165.028 13.9H150.32v3.936h14.708z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2858b3",
    d: "M165.028 9.96H150.32v3.936h14.708z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M70.801 11.5c0 6.33-5.16 11.5-11.48 11.5S47.84 17.83 47.84 11.5 53 0 59.32 0s11.481 5.17 11.481 11.5zm-11.48 8.77c4.812 0 8.755-3.95 8.755-8.77 0-4.82-3.943-8.77-8.755-8.77-4.813 0-8.756 3.95-8.756 8.77 0 4.82 3.943 8.77 8.756 8.77z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M11.48 20.27c-4.812 0-8.755-3.95-8.755-8.77 0-4.82 3.943-8.77 8.755-8.77 2.436 0 4.581.987 6.205 2.555l1.913-1.916A11.378 11.378 0 0 0 11.481 0C5.16 0 0 5.17 0 11.5S5.16 23 11.48 23c3.19 0 6.03-1.278 8.118-3.369l-1.913-1.916c-1.624 1.568-3.77 2.555-6.204 2.555z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M94.68 20.27c-4.812 0-8.755-3.95-8.755-8.77 0-4.82 3.943-8.77 8.755-8.77 2.436 0 4.581.987 6.205 2.555l1.913-1.916A11.378 11.378 0 0 0 94.68 0C88.36 0 83.2 5.17 83.2 11.5S88.36 23 94.68 23c3.19 0 6.03-1.278 8.118-3.369l-1.913-1.916a8.755 8.755 0 0 1-6.204 2.555z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M27.305.64H24.58v21.78h2.725z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M78.395 7.43H75.67v14.985h2.725z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M43.375.64H40.65v21.78h2.725z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M42.041 10.11H25.98v2.73h16.061z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M122.226 19.63H109.18v2.73h13.046z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M122.226.64H109.18v2.73h13.046z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M76.999 5.228L72.36.64h9.277z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M113.177 11.968c0 1.22-.812 1.975-1.914 1.975-1.101 0-1.913-.697-1.913-1.975V9.18h.754v2.846c0 .813.522 1.22 1.16 1.22.637 0 1.16-.407 1.16-1.22V9.18h.753z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M115.5 13.876h.754V9.23h-.754zm1.797-2.497l1.914-2.149h-.928l-1.971 2.149 2.145 2.497h.928z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M124.197 13.876l-1.333-1.8h-.87v1.8h-.754V9.23h1.681c.928 0 1.566.58 1.566 1.452 0 .639-.348 1.104-.87 1.336l1.392 1.917h-.812zm-2.145-2.497h.927c.522 0 .812-.29.812-.755s-.29-.755-.812-.755h-.927z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M129.707 13.07h-2.087l-.348.755h-.812l2.03-4.705h.231l2.03 4.705h-.812zm-1.044-2.556l-.753 1.917h1.565z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M133.534 13.876h-.754V9.23h.754z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M139.677 9.236v4.705h-.232l-2.841-3.253v3.137h-.754V9.12h.232l2.841 3.194V9.178h.754z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M145.133 9.869h-2.32v1.22h1.74v.638h-1.74v1.452h2.378v.697h-3.131V9.23h3.073z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogoPhone);
export default __webpack_public_path__ + "static/media/footer_logo_phone.b4c5bf351f4d194dcdded9610ddcd6e8.svg";
export { ForwardRef as ReactComponent };